<div class="row">
    <div class="col-sm-12">
        <div class="c-form-group">
            <label class="label-lg">Template</label>
            <ng-container *ngIf="ddfs && ddfGroups">
                <simple-tiny
                    [model]="textConfig[templateLabel]"
                    [ddfs]="ddfs"
                    [ddfGroups]="ddfGroups"
                    (onEditorKeyup)="setHeader($event)"
                    id="2"
                    [uglyDdfs]="true"
                    [extendedValidElements]="sharedService.extendedValidElements"
                ></simple-tiny>
            </ng-container>
            <div class="clearfix"></div>
        </div>
        <div class="c-form-group__hint">&nbsp;</div>
        <div class="clearfix"></div>
    </div>
    <div class="col-sm-12" *ngIf="textConfig.background">
        <div class="c-form-group">
            <div class="c-form-group__label">
                <label for="backgroundColor">Background Color</label>
            </div>
            <div
                class="input-group"
                [(colorPicker)]="textConfig.background"
                [cpAlphaChannel]="'disabled'"
                [cpOutputFormat]="'hex'"
                [cpPosition]="'top'"
            >
                <input
                    id="backgroundColor"
                    cclFormInput
                    type="text"
                    [(ngModel)]="textConfig.background"
                    class="c-form-group__input form-control"
                />

                <div class="input-group-append">
                    <span
                        class="c-color-picker input-group-text"
                        [ngStyle]="{ 'background-color': textConfig.background }"
                        >&nbsp;</span
                    >
                </div>
            </div>
            <div class="c-form-group__hint">&nbsp;</div>
        </div>
    </div>
    <div class="col-sm-12" *ngIf="textConfig.textColor">
        <div class="c-form-group">
            <div class="c-form-group__label">
                <label for="textColor">Text Color</label>
            </div>
            <div
                class="input-group"
                [(colorPicker)]="textConfig.textColor"
                [cpAlphaChannel]="'disabled'"
                [cpOutputFormat]="'hex'"
                [cpPosition]="'top'"
            >
                <input
                    id="textColor"
                    cclFormInput
                    type="text"
                    [(ngModel)]="textConfig.textColor"
                    class="c-form-group__input form-control"
                />

                <div class="input-group-append">
                    <span
                        class="c-color-picker input-group-text"
                        [ngStyle]="{ 'background-color': textConfig.textColor }"
                        >&nbsp;</span
                    >
                </div>
            </div>
            <div class="c-form-group__hint">&nbsp;</div>
        </div>
    </div>
</div>
